import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface RequireAnyPermissionProps {
  anyOf: string[];
}

const RequireAnyPermission: React.FC<RequireAnyPermissionProps> = ({ anyOf }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }

  // Admin zawsze ma dostęp (sprawdzamy z uwzględnieniem wielkości liter)
  if (user?.role && String(user.role).toLowerCase() === 'admin') {
    return <Outlet />;
  }

  // Jeśli brak mapy uprawnień → przepuszczamy (wsteczna kompatybilność)
  const map = user?.permissions;
  if (!map || Object.keys(map).length === 0) {
    return <Outlet />;
  }

  const allowed = anyOf.some((key) => !!map[key as keyof typeof map]);
  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAnyPermission;


